// Constantes del módulo Pre-Visit Planning (Módulo D — BillingV2).

/**
 * TEMPORAL: acceso restringido a producción. Solo estos IDs de empleado pueden
 * entrar al módulo mientras es piloto; el resto ve "Access denied".
 *
 * La lista se configura por entorno con REACT_APP_PREVISIT_EMPLOYEES (IDs
 * separados por coma, ej: "68,89,90"). Para agregar/quitar gente basta editar
 * el .env correspondiente y reconstruir (CRA inyecta las env vars en build
 * time, no se leen en caliente).
 *
 * Si la variable no está definida se usa DEFAULT_PREVISIT_EMPLOYEE_IDS, para
 * que un deploy sin configurar no deje al piloto sin acceso. Para cerrar el
 * módulo por completo, definir la variable vacía: REACT_APP_PREVISIT_EMPLOYEES=
 *
 * Cuando el módulo se abra a más roles, mover esto al RBAC (roleRoutePermissions
 * + TAB_MODULES) y borrar este allowlist.
 */
const DEFAULT_PREVISIT_EMPLOYEE_IDS = [68, 89, 90, 74, 66, 31, 27, 55];

/** Parsea "68, 89,90" → [68, 89, 90]; descarta entradas no numéricas. */
const parseEmployeeIds = (raw) =>
  raw
    .split(",")
    .map((id) => Number(id.trim()))
    .filter((id) => Number.isFinite(id) && id > 0);

const rawAllowedEmployees = process.env.REACT_APP_PREVISIT_EMPLOYEES;

export const PREVISIT_ALLOWED_EMPLOYEE_IDS =
  rawAllowedEmployees === undefined
    ? DEFAULT_PREVISIT_EMPLOYEE_IDS
    : parseEmployeeIds(rawAllowedEmployees);

/** ¿Este empleado puede acceder al módulo? (compara numéricamente) */
export const canEmployeeAccessPrevisit = (employeeId) =>
  PREVISIT_ALLOWED_EMPLOYEE_IDS.includes(Number(employeeId));

/** Estados del prep packet por cita. */
export const PREP_STATUS = {
  PENDING: "pending",
  READY: "ready",
  REVIEWED: "reviewed",
};

/** Mapa estado → tono semántico + label (siempre texto + color, nunca solo color). */
export const PREP_STATUS_META = {
  [PREP_STATUS.PENDING]: { tone: "warn", label: "Prep pending" },
  [PREP_STATUS.READY]: { tone: "info", label: "Prep ready" },
  [PREP_STATUS.REVIEWED]: { tone: "ok", label: "Reviewed by provider" },
};

/** Claves del selector de fecha del shell. */
export const DATE_KEYS = {
  TODAY: "today",
  TOMORROW: "tomorrow",
};

export const DATE_OPTIONS = [
  { value: DATE_KEYS.TODAY, label: "Today" },
  { value: DATE_KEYS.TOMORROW, label: "Tomorrow" },
];

/** Prioridad de care gap → tono. */
export const GAP_PRIORITY_TONE = {
  high: "crit",
  medium: "warn",
  low: "muted",
};
